import emitter, { events } from '@/event-bus'

import { getAccessToken } from '@/api'
import { setDomainToken } from '@/utils/domainToken'
// 快捷入口点击逻辑
// 系统 code
// ● meiye-v2：美业数据大脑
// ● np：全球新品
// ● amz：数选
// ● amz：亚马逊数据洞察
// ● amzen：亚马逊数据洞察英文版
// ● npen：新品英文版
// ● touke：商家后台
// ● dssc：数选供应链
// ● tkapp：数美链APP
// ● ct: 智能宣称工具
import { useLoginData } from '@/hooks/useLoginData'
import useTokenLoginSML from '@/hooks/useTokenLoginSML'

const dataLoginUrl = import.meta.env.VITE_APP_API_DATA_LOGIN_URL

/** 大系统 数据大脑 */
const meiyev2Url = import.meta.env.VITE_APP_API_DATA_URL
/** 全球新品 */
const npUrl = import.meta.env.VITE_APP_API_NP_URL

/** 亚马逊洞察 */
const amzUrl = import.meta.env.VITE_APP_API_AMZ_URL
/** 全球新品海外版 */
const npenUrl = import.meta.env.VITE_APP_API_NPEN_URL
/** 亚马逊洞察海外版 */
const amzenUrl = import.meta.env.VITE_APP_API_AMZEN_URL

/** 数选供应链 */
const dscmUrl = import.meta.env.VITE_APP_API_DSCM_URL
/** 拓客后台 */
const tkradarUrl = import.meta.env.VITE_APP_API_TKRADAR_URL
/** 报告系统 */
const rptUrl = import.meta.env.VITE_APP_API_RPT_URL
/** 智能宣称工具 */
const ctUrl = import.meta.env.VITE_APP_API_CT_URL

export const useQuickEntry = () => {
  const { init, getSystem } = useLoginData()

  const { isSmlUser, jumpToSml } = useTokenLoginSML()

  const isQuickEntryTipsVisableLocalKey = 'isQuickEntryTipsVisable'
  // 是否显示快捷入口提示信息， 关闭后不再显示，默认显示
  const isQuickEntryTipsVisable = ref(!localStorage.getItem(isQuickEntryTipsVisableLocalKey))

  const jumpToMeiye = async (item: { code: string; url: string; redirectUrl: string }, options) => {
    await init()
    function openDialog(data) {
      emitter.emit(events.showSystemRenewalDialog, data)
    }
    const jumpUrlMap = {
      'meiye-v2': meiyev2Url,
      'np': npUrl,
      'amz': amzUrl,
      'amzen': amzenUrl,
      'npen': npenUrl,
      'dssc': dscmUrl,
      'tuoke': tkradarUrl,
      'rpt': rptUrl,
      'ct': ctUrl,
    }
    getSystem(item.code).then((res: any) => {
      // 判断是跳转还是打开弹窗
      if (res.stage === 0) {
        getAccessToken({ sysCode: item.code }).then((resp: any) => {
          if (['amz', 'amzen'].includes(item.code)) {
            // 亚马逊是外部系��，获取redirectUrl跳转
            window.open(resp.redirectUrl)
            setDomainToken(resp.homeToken)
          } else if (options?.callback) {
            options?.callback()
            setDomainToken(resp.token)
          } else {
            // 内部系统跳转
            if (item.code === 'meiye-v2' || item.code === 'dssc') {
              window.open(`${jumpUrlMap[item.code]}#/auth?t=${resp.token}${item.redirectUrl ? '&next=' + item.redirectUrl : ''}`, '_blank')
            } else {
              window.open(`${jumpUrlMap[item.code]}${['np', 'npen', 'rpt', 'ct'].includes(item.code) ? '' : '#/'}auth?t=${resp.token}&redirectUrl=${item.redirectUrl}`, '_blank')
            }
            setDomainToken(resp.token)
          }
        }).catch((error) => {
          // 报告系统，如果没有购买，打开介绍的 pdf
          // if (item.code === 'rpt' && error.resultCode === 'FORBIDDEN') {
          //   window.open('https://materialdb.zhaoyl.com/fed/report/%E7%BE%8E%E4%B8%9A%E9%A2%9C%E7%A9%B6%E9%99%A2%EF%BC%9A%E5%AE%9A%E5%88%B6%E6%8A%A5%E5%91%8A%E6%9C%8D%E5%8A%A1%E4%BB%8B%E7%BB%8D%EF%BC%88%E8%AF%A6%E7%BB%86%E6%A1%88%E4%BE%8B%E5%B1%95%E7%A4%BA%EF%BC%89-2025.pdf')
          // } else {
          //   // 打开弹窗
          //   openDialog({ ...item, errorType: error.resultCode, moreData: error.moreData })
          // }

          openDialog({ ...item, errorType: error.resultCode, moreData: error.moreData })
        })
      } else if (res.stage === 1) {
        // 需校验地理位置
        openDialog({ ...item, key: res.key, verifyGeography: true })
      }
    }).catch((error) => {
      console.log('error', error)
      // if (error.resultCode === 'NOT_EXISTS') {
      //   // 未绑定数据系统账号 --- 跳转联合登陆页
      //   window.open(dataLoginUrl)
      // } else {
      // 打开弹窗
      openDialog({ ...item, errorType: error.resultCode, moreData: error.moreData })
      // }
    })
  }

  const handleClick = (item: any, options) => {
    if (item.code === 'report') {
      // 报告和咨询
      emitter.emit(events.showSystemRenewalDialog, {
        ...item,
      })
    } else if (item.code === 'tuoke') {
      if (isSmlUser) {
        jumpToSml()
      } else {
        // window.$message?.warning('商家后台暂不支持非SML用户使用')
        emitter.emit(events.showSystemRenewalDialog, {
          ...item,
        })
      }
    } else {
      jumpToMeiye(item, options)
    }
  }

  const hideQuickEntryTip = () => {
    localStorage.setItem(isQuickEntryTipsVisableLocalKey, 'false')
    isQuickEntryTipsVisable.value = false
  }

  return {
    isQuickEntryTipsVisable,
    handleClick,
    hideQuickEntryTip,
  }
}
